import { z } from 'zod'

// --- Point (API response) ---
export interface Point {
  id: number
  id_client: number
  id_user: number
  id_branch_office: number
  id_company: number
  points: number
  used_points: number
  amount: number
  transaction_type: 'add' | 'spend'
  datetime_transaction: string
  datetime_expiration: string
  is_valid: boolean
  comment: string
}

// --- Add points form schema ---
export const addPointFormSchema = z
  .object({
    id_client: z.number({ required_error: 'Cliente es requerido' }),
    amount: z.number({ required_error: 'Monto es requerido' }),
    id_branch_office: z.number({ required_error: 'Sucursal es requerida' }),
    comment: z.string().optional().default(''),
    is_devolution: z.boolean().optional().default(false),
    points: z.number().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.is_devolution) {
      if (!data.amount || data.amount < 1) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Monto debe ser mayor a 0',
          path: ['amount'],
        })
      }
    } else {
      if (!data.points || data.points < 1) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Puntos debe ser mayor a 0',
          path: ['points'],
        })
      }
    }
  })

export type AddPointFormData = z.infer<typeof addPointFormSchema>

// --- Redeem points form schema ---
// Points and comment are derived from product selection (not managed by RHF)
export const redeemPointFormSchema = z.object({
  id_client: z.number({ required_error: 'Cliente es requerido' }),
  id_branch_office: z.number({ required_error: 'Sucursal es requerida' }).min(1, 'Sucursal es requerida'),
})

export type RedeemPointFormData = z.infer<typeof redeemPointFormSchema>

// --- Point filters ---
export interface PointFilters {
  page: number
  limit: number
  transaction_type?: 'add' | 'spend'
  is_valid?: boolean
  date_from?: string
  date_to?: string
  amount_min?: number
  amount_max?: number
  points_min?: number
  points_max?: number
  search?: string
  sort_by?: string
  sort_order?: 'asc' | 'desc'
}
